<template>
  <div class="antialiased">
    <Sidebar/>
    <div class="page">
      <Header
        @keyup="_search"
        hint="Ketik nama vendor"
        @refresh="(filter.paginate.current_page = 1), (filter.name = ''), _get()"
      />
      <div class="content">
        <div class="container">
          <!-- This page to Header  -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">Vendor</h2>
              </div>
            </div>
            <div class="col-auto">
              <div class="row justify-content-end">
                <div class="col-auto">
                  <div class="input-icon">
                    <span class="input-icon-addon"> <i class="fe fe-align-left"></i> </span>
                    <select
                      class="form-control"
                      v-model="filter.paginate.per_page"
                      @change="_get">
                      <option
                        v-for="(num, i) in [25,50,100,999]"
                        v-html="num == 999 ? 'Semua' : num"
                        :value="num"
                        :key="i">
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-auto">
                  <button class="btn btn-primary" @click="_add"> Tambah </button>
                </div>
              </div>
            </div>
          </div>

          <Skeleton type="table" :length="filter.paginate.per_page" class="mt-3 bg-white" v-if="loading"/>
          <Nodata v-if="!loading && data.listOptimize.length == 0"/>

          <!-- This Page to Body -->
          <div class="box" v-if="!loading && data.listOptimize.length" >
            <div class="card">
              <div class="table-responsive">
                <table class="table table-vcenter table-hover card-table table-striped table-control">
                  <thead>
                    <tr class="text-muted">
                      <th>No</th>
                      <th>Vendor ID</th>
                      <th>Nama Vendor</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(vendor, index) in data.listOptimize" :key="index">
                      <td>{{ filter.paginate.from + index}}</td>
                      <td>{{vendor.id}}</td>
                      <td>{{vendor.name}}</td>

                      <td class="pos-relative">
                        <div class="btn-group option center">
                          <button
                            class="btn btn-white btn-pill"
                            @click="_edit(vendor)"
                            v-html="ic('edit')">
                          </button>
                          <button
                            class="btn btn-white btn-pill text-danger"
                            @click="_delete(vendor.id)"
                            v-html="ic('trash')">
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <b-pagination
            v-if="data.listOptimize.length > 0 && !loading"
            class="mt-5 justify-content-center"
            v-model="filter.paginate.current_page"
            :total-rows="filter.paginate.total"
            :per-page="filter.paginate.per_page"
            @change="_pageChange"
          />

        </div>
      </div>
    </div>

    <ModalEdit
      :config.sync = "modal.edit.config"
      :isSubmit.sync="modal.edit.isSubmit"
      :initData="modal.edit.data"
      @submit="modal.edit.action"
    />

    <ModalCreate
      :config.sync = "modal.create.config"
      :isSubmit.sync="modal.create.isSubmit"
      :status.sync="modal.create.status"
      @submit="modal.create.action"
    />

    <Confirm
      :id.sync="modal.delete.id"
      :title.sync="modal.delete.title"
      :isSubmit.sync="modal.delete.isSubmit"
      @submit="modal.delete.action"
    />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import ModalCreate from "./modals/form-create-vendor.vue"
import ModalEdit from "./modals/form-edit-vendor.vue"
import { mapState, mapActions } from "vuex";

export default {
  name: "Vendor",
  components: { ModalCreate , ModalEdit },

  data(){
    return{
      filter:{
        paginate:{
          from: 0,
          total: 0,
          per_page: 25,
          current_page: 1,
        },
        name: ''
      },
      loading:true,
      modal:{
        create: {
          config: { view: false, title: null },
          status: false,
          isSubmit: false,
          action: () => {}
        },
        edit: {
          data: null,
          isSubmit: false,
          action: () => {},
          config: { view: false, title: null },
        },
        delete: {
          id:null,
          title: null,
          isSubmit: false,
          action: () => {}
        }
      }
    }
  },
  mixins: [helper],
  computed: {
    ...mapState("vendor",['data','listOptimize']),
  },
  methods: {
    ...mapActions("vendor",["getVendorOptimize","delete"]),

    async _get(){
      this.loading = true
      const respone = await this.getVendorOptimize(this.filter)
      this.filter.paginate.from = respone.from
      this.filter.paginate.total = respone.total
      this.loading = false
    },
    _add(){
      this.modal.create.config = {view: true, title: 'Tambah Vendor'}
      this.modal.create.action = async (request) => {
        try{
          const response = await this.axios.post('vendor', request)
          this.toast(response.data.message);
          this.modal.create.config.view = false
          this.modal.create.isSubmit = false;
          this.modal.create.status = true;
          this._get()
        }catch(error) {
          console.log(error)
          this.toast(error);
          this.modal.create.isSubmit = false;
        }
      }
    },
    _edit(vendor){
      this.modal.edit.config = {view: true, title: 'Ubah Vendor'}
      this.modal.edit.data = vendor;
      this.modal.edit.action = async (request) => {
        try{
          const response = await this.axios.put('vendor/'+vendor.id, request)
          this.toast(response.data.message);
          this.modal.edit.config.view = false
          this.modal.edit.isSubmit = false;
          this._get()
        }catch(error) {
          this.toast(error);
          this.modal.edit.isSubmit = false;
        }
      }
    },
    _delete(id){
      this.modal.delete.id = id
      this.modal.delete.title = 'Yakin ingin menghapus data Vendor ini?'
      this.modal.delete.action = async () => {
        try{
          const response = await this.axios.delete('vendor/'+id)
          this.toast(response.data.message);
          this.modal.delete.id = null
          this._get()
        }catch(error) {
          this.onError(err);
          this.toast(error);
          this.modal.delete.isSubmit = false
        }
      }
    },
    _pageChange(page) {
      this.filter.paginate.current_page = page;
      this._get()
    },
    _search(name){
      this.filter.name = name;
      this._get();
    }
  },
  mounted(){
    this._get()
  }
}
</script>

<style lang="scss" scoped>
hr{
  margin: 0 !important
}
</style>
